import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    show: false,
};

const loaderSlice = createSlice({
    name: 'Loader',
    initialState,
    reducers: {
        showLoader: (state) => {
            state.show = true;
        },
        hideLoader: (state) => {
            state.show = false;
        },
    },
});

export const {
    showLoader,
    hideLoader
} = loaderSlice.actions;

export default loaderSlice.reducer;
